import { render } from "./CreateNewTask.vue?vue&type=template&id=723a5e3e&scoped=true"
import script from "./CreateNewTask.vue?vue&type=script&lang=js"
export * from "./CreateNewTask.vue?vue&type=script&lang=js"

import "./CreateNewTask.vue?vue&type=style&index=0&id=723a5e3e&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-723a5e3e"]])

export default __exports__